import React, { ReactElement } from "react";
import { Field, ErrorMessage, useFormikContext } from "formik";
import { InputText, InputTextProps } from "primereact/inputtext";
import ExtendedLabel from "../../extendedLabel/extendedLabel";
import { AdvisoryText } from "../../AdvisoryText";

interface InputProps extends InputTextProps {
  label: string;
  name: string;
  value: any;
  warn: string;
  fieldadv: string;
  warnType?: string;
  hint: string;
  Body?: React.FC;
  isRequired?: boolean;
  extendedlabel?: string | ReactElement;
}
export default function Input(props: InputProps) {
  const { name, label, warn, warnType, fieldadv, extendedlabel, isRequired, Body, ...rest } = props;
  const { setFieldTouched, setFieldValue } = useFormikContext();

  return (
    <div className="flex flex-col w-full py-2" id={name.split(".").pop()}>
      <div className="flex items-start gap-3">
        {" "}
        <div className="extentedlabel-container">
          {label && !props?.hidden && (
            <label className={isRequired ? "isRequired" : ""} htmlFor={name} id={name.split(".").pop()}>
              {" "}
              {label}
            </label>
          )}
          {extendedlabel && <ExtendedLabel text={extendedlabel} />}
        </div>
      </div>
      {Body && <Body />}
      <Field
        alt={name}
        name={name}
        {...rest}
        value={rest.value ?? ""}
        as={InputText}
        onChange={(e: any) => {
          setFieldTouched(name, true, true);
          setFieldValue(name, e.target.value);
        }}
      />

      {warn && <AdvisoryText type={warnType ?? "warn"} label={warn} Body={() => <>{warn}</>} />}
      {fieldadv && <AdvisoryText type={warnType ?? "fieldadv"} label={fieldadv} Body={() => <>{fieldadv}</>} />}
      <ErrorMessage name={name ?? ""} render={(msg) => <div className="error">{msg}</div>} />
    </div>
  );
}
